import { defineMessages } from "react-intl";

import {
	liveDonorScreeningInProgressMessages,
	validator
} from "lib/build/forms/ktx/basic-registration-data/liveDonorScreening";

import { FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	liveDonorScreening: {
		id: "ktx.form.live_donor_screening.title",
		defaultMessage: "Élő donor kivizsgálás"
	},
	liveDonorScreeningInProgress: {
		id: "ktx.form.live_donor_screening.in_progress",
		defaultMessage: "Kivizsgálás folyamatban"
	}
});

const fieldset: FieldsetData = {
	rows: [
		{
			columns: [
				{
					width: 12,
					field: {
						type: "field",
						path: ["liveDonorScreeningInProgress"],
						label: messages.liveDonorScreeningInProgress,
						errorMessages: genericErrorMessages,
						input: {
							type: "button-group",
							props: {
								labels: liveDonorScreeningInProgressMessages
							}
						}
					}
				}
			]
		}
	]
};

export const node: LeafNode = {
	id: "ktx_liveDonorScreening",
	value: {
		schemaId: "liveDonorScreening",
		title: messages.liveDonorScreening,
		validator,
		fieldset,
		applyCurrentDate: false
	}
};
